import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useSelector, useDispatch } from "react-redux";
import Modal from ".";
import Button from "../Button";
import ComboBoxStation from "../ComboBoxStation/ComboBoxStation";
import DataTable from "../DataTable";
import Icon from "../Icon";
import { Input, Select } from "../Inputs";
import TitleValue from "../TitleValue";
import moment from "moment";
import { getActiveCertificatesRequest } from "../../redux/actions/certificates";
import { API_GET, API_POST, API_PUT } from "../../helpers/api";
import { setNotification } from "../../helpers/notification";
import ModalConfirmation from "./ModalConfirmation";
import ModalCertificate from "./ModalCertificate";
import { monthsAndResourceTypes } from "../../constants/translations";
import PriceInput from "../Inputs/PriceInput";
import { convertAmountToFrontend } from "../../helpers/convert";
export default function ModalEditSellOffer(props) {
  const { t, isOpen, toggle, editedOffer, selectedContract, row } = props;
  const dispatch = useDispatch();

  const activeCertificates = useSelector(
    (state) => state.certificates.activeList
  );
  const [offerValues, setOfferValues] = useState(editedOffer);
  const [copiedOfferValues, setCopiedOfferValues] = useState(editedOffer);
  // eslint-disable-next-line
  const [offerValuesReference, setOfferValuesReference] = useState(editedOffer);
  const [offers, setOffers] = useState([]);
  const [selectedFilter, setSelectedFilter] = useState({
    station: "",
    period: "",
  });
  const [selectedCertificates, setSelectedCertificates] = useState([]);
  const [selectedCertificatesReference, setSelectedCertificatesReference] =
    useState([]);
  const [inspectedCertificateId, setInspectedCertificateId] = useState();
  const [loading, setLoading] = useState(false);
  const [confirmationOpen, setConfirmationOpen] = useState(false);
  const [listedActiveCertificates, setListedActiveCertificates] = useState([]);

  const translations = monthsAndResourceTypes(t);

  const activeCertificatesColumns = [
    {
      name: t("pages.default.certificates.table.stationName"),
      selector: "stationName",
      sortable: true,
    },
    {
      name: t("pages.default.certificates.table.resourceType"),
      selector: "resourceType",
      sortable: true,
      cell: (row) => {
        return translations[row.resourceType];
      },
    },
    {
      name: t("pages.default.certificates.table.productionPeriod"),
      selector: "productionPeriod",
      sortable: true,
      cell: (row) => {
        return `${translations[row.productionMonth]}/${row.productionYear}`;
      },
    },
    {
      name: t("pages.default.certificates.table.documentCount"),
      selector: "amount",
      sortable: true,
      cell: (row) => {
        return convertAmountToFrontend(row.amount);
      },
    },
    {
      name: t("pages.default.certificates.table.process"),
      selector: "stationId",
      sortable: false,
      cell: (row) => {
        return (
          <div style={{ display: "flex" }}>
            <Button
              suffixIcon="search"
              type="secondary"
              onClick={() => setInspectedCertificateId(row.id)}
            />
            <Button
              suffixIcon="plus"
              type="primary"
              onClick={() => selectCertificate(row)}
              disabled={selectCertificateIsDisabled(row)}
            />
          </div>
        );
      },
    },
  ];
  const selectedCertificatesColumns = [
    {
      name: t("pages.default.certificates.table.stationName"),
      selector: "stationName",
      sortable: true,
    },
    {
      name: t("pages.default.certificates.table.resourceType"),
      selector: "resourceType",
      sortable: true,
      cell: (row) => {
        return translations[row.resourceType];
      },
    },
    {
      name: t("pages.default.certificates.table.productionPeriod"),
      selector: "productionPeriod",
      sortable: true,
      cell: (row) => {
        return `${translations[row.productionMonth]}/${row.productionYear}`;
      },
    },
    {
      name: "YEK-G " + t("pages.default.certificates.table.documentCount"),
      selector: "documentCount",
      sortable: true,
      cell: (row) => {
        return (
          <Input
            type="number"
            placeholder={`Max ${row.totalAmount}`}
            value={row.selledRemaningAmount}
            onChange={(e) => rowSellAmountChange(e, row)}
            max={row.totalAmount}
            min={1}
          />
        );
      },
    },
    {
      name: t("pages.default.certificates.table.process"),
      selector: "stationId",
      sortable: false,
      cell: (row) => {
        return (
          <div style={{ display: "flex" }}>
            <Button
              suffixIcon="minus"
              type="destructive"
              disabled={parseInt(row.selledRemaningAmount) === 0}
              onClick={() => removeCertificate(row)}
            />
          </div>
        );
      },
    },
  ];

  useEffect(() => {
    getActiveCertificates();
    setTimeout(() => {
      getOfferDetail();
    }, 100);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [editedOffer]);

  useEffect(() => {
    // deep copy
    let certificates = JSON.parse(JSON.stringify(activeCertificates));
    let listedCertificates = certificates.reduce((acc, value) => {
      let selectedCertificate = selectedCertificatesReference.find((item) => {
        return item.id === value.id;
      });
      acc.push({
        ...value,
        totalAmount: selectedCertificate
          ? selectedCertificate.selledRemaningAmount + value.amount
          : value.amount,
      });
      return acc;
    }, []);
    // eğer gelen aktif sertifikalarda kullanılan sertifikalar yoksa onları aktif sertifikalara pushla
    let notComingFromActives = selectedCertificatesReference.reduce(
      (acc, value) => {
        let cert = listedCertificates.find((item) => {
          return item.id === value.id;
        });
        if (!cert) {
          acc.push({
            ...value,
            totalAmount: value.selledRemaningAmount,
          });
        }
        return acc;
      },
      []
    );
    let listedActiveCerts = listedCertificates.concat(notComingFromActives);
    setListedActiveCertificates(listedActiveCerts);
  }, [activeCertificates, selectedCertificatesReference]);

  const getOfferDetail = async () => {
    try {
      let resOffers = await API_GET(`exchange-order/search`, {
        orderGroupId: editedOffer.orderGroupId,
      });
      let offers = resOffers.data.items;
      setOffers(offers);
      let certificatesInit = [];
      for (let offer of offers) {
        let certificate = await API_GET(`certificate/${offer.certificateId}`);
        if (offer.remainingAmount)
          certificatesInit.push({
            ...certificate.data,
            stationName: certificate.data.productionData.station.stationName,
            productionPeriod: certificate.data.productionData.term,
            productionMonth: moment(
              certificate.data.productionData.term
            ).format("M"),
            productionYear: moment(certificate.data.productionData.term).format(
              "YYYY"
            ),
            selledAmount: offer.amount,
            selledRemaningAmount: offer.remainingAmount,
            totalAmount: certificate.data.amount + offer.remainingAmount,
            offerId: offer.id,
            offerStatus: offer.status,
          });
      }
      setSelectedCertificates(certificatesInit);
      setSelectedCertificatesReference(certificatesInit);
    } catch (err) {}
  };

  const getActiveCertificates = async () => {
    dispatch(
      getActiveCertificatesRequest({
        organizationId: editedOffer.organizationId,
        stationId: selectedFilter.station
          ? selectedFilter.station.stationId
          : "",
        resourceType: selectedContract.type,
        month: selectedFilter.period
          ? moment(selectedFilter.period).format("M")
          : "",
        year: selectedFilter.period
          ? moment(selectedFilter.period).format("YYYY")
          : "",
        certificateStatus: "ACTIVE",
        dontShowOutOfDate: true,
        size: 1000,
      })
    );
  };

  const selectCertificate = (row) => {
    // deep copy
    let certificates = JSON.parse(JSON.stringify(selectedCertificates));
    certificates.push({ ...row, selledRemaningAmount: "" });
    certificates.sort((a, b) => {
      var aP = a.productionPeriod,
        bP = b.productionPeriod;

      return aP && bP
        ? a.productionPeriod.localeCompare(b.productionPeriod)
        : aP - bP;
    });
    setSelectedCertificates(certificates);
  };

  const removeCertificate = (row) => {
    // deep copy
    let certificates = JSON.parse(JSON.stringify(selectedCertificates));
    let deletedCertificateIndex = certificates.findIndex((certificate) => {
      return certificate.id === row.id;
    });
    //deep copy
    let listedCertificates = JSON.parse(
      JSON.stringify(listedActiveCertificates)
    );
    // eslint-disable-next-line array-callback-return
    listedCertificates.map((item) => {
      if (item.id === row.id) {
        item.amount = item.totalAmount;
      }
    });
    certificates.splice(deletedCertificateIndex, 1);
    setSelectedCertificates(certificates);
    setListedActiveCertificates(listedCertificates);
  };

  const selectCertificateIsDisabled = (row) => {
    // deep copy
    let certificates = JSON.parse(JSON.stringify(selectedCertificates));
    let certificate = certificates.filter((certificate) => {
      return certificate.id === row.id;
    });
    return certificate[0];
  };

  const rowSellAmountChange = (e, row) => {
    // deep copy
    let certificates = JSON.parse(JSON.stringify(selectedCertificates));
    //deep copy
    let listedCertificates = JSON.parse(
      JSON.stringify(listedActiveCertificates)
    );

    let value = parseInt(e.target.value ? e.target.value : 0);
    // eslint-disable-next-line array-callback-return
    listedCertificates.map((item) => {
      if (item.id === row.id && row.totalAmount >= value) {
        item.amount = row.totalAmount - value;
      }
    });
    // eslint-disable-next-line array-callback-return
    certificates.map((certificate) => {
      if (certificate.id === row.id) {
        certificate.selledRemaningAmount = value;
      }
    });
    setSelectedCertificates(certificates);
    setListedActiveCertificates(listedCertificates);
  };

  const periodChange = (e) => {
    setSelectedFilter({
      ...selectedFilter,
      period: e.target.value,
    });
  };
  const stationChange = (e) => {
    setSelectedFilter({
      ...selectedFilter,
      station: e,
    });
  };
  const inputChange = (e) => {
    setOfferValues({
      ...offerValues,
      [e.target.name]: e.target.value,
    });
  };

  const checkOffersIncluded = (id) => {
    let o = offers.filter((item) => {
      return item.id === id;
    });
    if (o.length > 0) {
      return true;
    }
    return false;
  };
  const checkCertificatesIncluded = (id) => {
    let c = selectedCertificates.filter((item) => {
      return item.offerId === id;
    });
    if (c.length > 0) {
      return true;
    }
    return false;
  };

  const checkOffersPrice = () => {
    if (offerValues.price === copiedOfferValues.price) {
      return true;
    }
    return false;
  };

  const checkOffersAmount = (a) => {
    let o = offers.filter((item) => {
      return (
        item.certificateId === a.id &&
        item.remainingAmount === a.selledRemaningAmount
      );
    });
    if (o.length > 0) {
      return true;
    }
    return false;
  };

  const validateCertificateInputs = () => {
    let emptyCertificates = selectedCertificates.filter((item) => {
      return !item.selledRemaningAmount;
    });
    if (emptyCertificates.length > 0) {
      return false;
    }
    return true;
  };

  const checkArrayDifference = () => {
    // if any additions or edites from certificates
    let arrayDifference = selectedCertificates.filter(
      (edited) =>
        !selectedCertificatesReference.some(
          (reference) =>
            reference.id === edited.id &&
            reference.selledRemaningAmount === edited.selledRemaningAmount
        )
    );
    // if any removes or edites from certificates
    let arrayDifferenceRemoves = selectedCertificatesReference.filter(
      (reference) =>
        !selectedCertificates.some(
          (edited) =>
            edited.id === reference.id &&
            edited.selledRemaningAmount === reference.selledRemaningAmount
        )
    );
    if (arrayDifference.length > 0 || arrayDifferenceRemoves.length > 0) {
      return true;
    }
    return false;
  };

  const validateDifference = () => {
    if (
      !checkArrayDifference() &&
      offerValues.price === offerValuesReference.price &&
      offerValues.status === offerValuesReference.status
    ) {
      return false;
    }
    return true;
  };

  const confirmationToggle = () => {
    if (selectedCertificates.length === 0) {
      setNotification(
        "error",
        t("pages.default.offerOperations.errors.editSellNoCertificatesSelected")
      );
      return;
    }
    if (!validateDifference()) {
      setNotification(
        "error",
        t("pages.default.offerOperations.errors.editSellNoChanges")
      );
      return;
    }
    if (!validateCertificateInputs()) {
      setNotification(
        "error",
        t("pages.default.offerOperations.errors.editSellFillAllCertificates")
      );
      return;
    }
    if (!offerValues.price) {
      setNotification("error", t("pages.default.offerOperations.errors.price"));
      return;
    }
    setConfirmationOpen(true);
  };
  const checkOrderStatus = () => {
    return copiedOfferValues.status !== offerValues.status;
  };
  const updateOffers = async () => {
    setLoading(true);
    let updatedOffer = {
      deleteRequests: [],
      updateRequests: [],
      createRequests: [],
      passiveRequests: [],
      activeRequests: [],
    };

    let alreadyIncluded = [];
    let newlyAdded = [];
    let removed = [];
    let orderStatus = checkOrderStatus(offerValues.status);

    for (let certificate of selectedCertificates) {
      if (certificate.offerId === undefined) {
        certificate.offerId = 0;
      }
      // status check
      if (orderStatus) {
        if (offerValues.status === "OPEN") {
          updatedOffer.activeRequests.push({ orderId: certificate.offerId });
        } else {
          updatedOffer.passiveRequests.push({ orderId: certificate.offerId });
        }
      }
      // removed check
      if (checkOffersIncluded(certificate.offerId)) {
        alreadyIncluded.push(certificate);
      } else {
        newlyAdded.push(certificate);
      }
    }
    // REMOVE
    for (let offer of offers) {
      if (offer.remainingAmount)
        if (!checkCertificatesIncluded(offer.id)) {
          removed.push({ orderId: offer.id });
        }
    }
    // UPDATE
    let updateResponse = [];
    for (let a of alreadyIncluded) {
      updateResponse.push({
        amount: a.selledRemaningAmount,
        price: offerValues.price,
        prevAmount: offerValues.remainingAmount,
        orderId: a.offerId,
        status: a.offerStatus,
        totalValue: row?.amount,
        remainingTotalValue: row?.remainingAmount,
        newRemainingTotalValue: selectedCertificates.reduce(
          (acc, certificate) => {
            acc += certificate.selledRemaningAmount;
            return acc;
          },
          0
        ),
      });
      // offers yada price dan bağımsız yapılacak bütün değişikliklerde bile var olan değerlerin updateResponse olarak  be tarafına gönderilmesi istendiği için aşağıda ki kontroller kaldırıldı
      // if (checkOffersAmount(a) || checkOffersPrice()) {
      //  updateResponse.push({
      //    amount: a.selledRemaningAmount,
      //    price: offerValues.price,
      //    prevAmount: offerValues.remainingAmount,
      //    orderId: a.offerId,
      //    status: a.offerStatus,
      //  });
      // }
    }
    // CREATE
    if (newlyAdded.length > 0) {
      // todo: burası sadeleştirilecek
      let body = await newlyAdded.reduce((acc, value) => {
        acc.push({
          organizationId: editedOffer.organizationId,
          certificateId: value.id,
          contractId: selectedContract.id,
          exchangeOrderType: "SELL",
          exchangeOrderStatus: offerValues.status,
          term: editedOffer.term,
          amount: value.selledRemaningAmount,
          price: offerValues.price,
          orderGroupId: editedOffer.orderGroupId,
          prevAmount: offerValues.remainingAmount,
          prevPrice: copiedOfferValues.price,
        });
        return acc;
      }, []);
      updatedOffer.createRequests = body;
    }
    updatedOffer.deleteRequests = removed;
    updatedOffer.updateRequests = updateResponse;
    await API_POST(`exchange-order/multi`, updatedOffer)
      .then(() =>
        setNotification(
          "success",
          t("pages.default.offerOperations.success.buyOfferUpdate")
        )
      )
      .catch((err) => setNotification("error", err?.response?.data?.message));
    toggle();
    setConfirmationOpen(false);
    setSelectedCertificates([]);

    setLoading(false);
  };

  return (
    <div>
      <Modal
        isOpen={isOpen}
        toggle={toggle}
        className="km__p--modal-edit-sell-offer"
      >
        <div className="km__p-modal-edit-sell-offer-header">
          <div className="km__p-modal-edit-sell-offer-header-close">
            <Icon name="x" size="16" onClick={() => toggle(false)} />
          </div>
          <div className="km__p-modal-edit-sell-offer-header-column">
            <Input
              type="text"
              label={t("pages.default.offerOperations.orderId")}
              value={editedOffer.shownId}
              disabled
            />
            <Input
              type="text"
              label={t("pages.default.offerOperations.transactionDirection")}
              value={t(
                `ui.default.offerTab.${editedOffer.orderType.toLowerCase()}`
              )}
              disabled
            />
            <Input
              type="text"
              label={t("pages.default.offerOperations.orderType")}
              value={"Standart"}
              disabled
            />
          </div>
          <div className="km__p-modal-edit-sell-offer-header-column">
            <Select
              label={t("pages.default.offerOperations.orderStatus")}
              options={[
                {
                  name: t("pages.default.offerOperations.active"),
                  value: "OPEN",
                },
                {
                  name: t("pages.default.offerOperations.passive"),
                  value: "DRAFT",
                },
              ]}
              value={offerValues.status}
              name="status"
              onChange={(e) => inputChange(e)}
            />
            <PriceInput
              type="number"
              label={t("pages.default.offerOperations.price")}
              name="price"
              min={selectedContract.minPrice}
              max={selectedContract.maxPrice}
              acceptDecimal
              onChange={(e) => inputChange(e)}
              value={offerValues.price}
            />
            <Input
              type="text"
              label={t("pages.default.offerOperations.totalPrice")}
              value={
                selectedCertificates.reduce((acc, certificate) => {
                  acc += certificate.selledRemaningAmount;
                  return acc;
                }, 0) * offerValues.price
              }
              disabled
            />
          </div>
        </div>
        <div className="km__p-modal-edit-sell-offer-body">
          <p className="km__u--text_title">
            {t("pages.default.certificates.activeTitle")}
          </p>
          <div className="km__p-modal-edit-sell-offer-body-filter">
            <ComboBoxStation
              t={t}
              selectedStation={selectedFilter.station}
              selectStation={stationChange}
            />
            <Input
              type="month"
              name="period"
              placeholder={t(
                "pages.default.certificates.table.productionPeriod"
              )}
              value={selectedFilter.period}
              onChange={periodChange}
            />
            <Button
              label={t("pages.default.offerOperations.filter")}
              type="primary"
              onClick={getActiveCertificates}
            />
          </div>
          <DataTable
            columns={activeCertificatesColumns}
            data={listedActiveCertificates}
            rowKey="id"
            defaultSortAsc={false}
            defaultSortedField={"productionPeriod"}
            paginationPerPage={5}
            pagination
          />
          <p className="km__u--text_title">
            {t("pages.default.offerOperations.toBeSold")}
          </p>
          <DataTable
            columns={selectedCertificatesColumns}
            data={selectedCertificates}
            rowKey="id"
            paginationPerPage={5}
            pagination
          />
          <div className="km__p-modal-edit-sell-offer-body-total">
            <TitleValue
              size="lg"
              title={t(
                "pages.default.certificates.detail.totalDocumentQuantity"
              )}
              value={selectedCertificates.reduce((acc, certificate) => {
                acc += certificate.selledRemaningAmount;
                return acc;
              }, 0)}
            />
            <Button
              label={t("pages.default.offerOperations.update")}
              type="primary"
              onClick={confirmationToggle}
            />
          </div>
        </div>
      </Modal>
      <ModalConfirmation
        toggle={() => setConfirmationOpen(false)}
        isOpen={confirmationOpen}
        header={t(
          "pages.default.offerOperations.confirmations.updateSellOffer.title"
        )}
        body={t(
          "pages.default.offerOperations.confirmations.updateSellOffer.description"
        )}
        approve={updateOffers}
        loading={loading}
      />
      {inspectedCertificateId && (
        <ModalCertificate
          t={t}
          certificateId={inspectedCertificateId}
          isOpen={inspectedCertificateId ? true : false}
          toggle={() => setInspectedCertificateId()}
          difCalculate={true}
        />
      )}
    </div>
  );
}
ModalEditSellOffer.propTypes = {
  t: PropTypes.func,
  isOpen: PropTypes.bool,
  toggle: PropTypes.func,
  offerValues: PropTypes.object.isRequired,
  selectedContract: PropTypes.object.isRequired,
};
ModalEditSellOffer.defaultProps = {
  isOpen: false,
};
